export default __webpack_public_path__ + "static/7-868781e9ef4d88e63320323b760529bd.png";